module.exports = "/img/icon-entertainment.svg?4d62d750fb406a8359396bdd488ecca3";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/icon-entertainment.svg
// module id = 7rTc
// module chunks = 46